import mutations from "./mutations";
import * as actions from "./actions";
import * as getters from "./getters";

// state
let state = {
	quiz: null,
	profile: null,
	regimenElements: null,
	allRegimenElements: null,
	userRegimenElements: null,
	notes: null,
	insights: null
}

export default {mutations, actions, state, getters}


// WEBPACK FOOTER //
// ./src/store/modules/quiz/index.js